import React, { Component } from "react";

import Modal from "../../../../component/modal/ModalTemplate";
import TextInput from "../../../../component/input/TextInput";

class PWModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { open, handleClose, idid, setValue } = this.props;
        const { findIdAction } = this.props;

        return(
            <>
                <Modal
                    open={open}
                    handleClose={handleClose}
                    modalTitle={"아이디 / 비밀번호 찾기"}
                    className={"react-modal"}
                >
                    <div className="modal-body">
                        <p>회원가입 시 등록한 계정 ID를 입력해 주세요.</p>
                        <p>해당 정보를 확인하여 입력하신 이메일로 인증 메일을 전달해 드립니다.</p>
                        <div className="d-flex align-items-center pt-3">
                            <label className={"pe-4 text-nowrap"}>계정 ID</label>
                            <TextInput
                                className="form-control d-inline"
                                type="text"
                                id="idid"
                                value={idid}
                                onChange={setValue}
                                onKeyDown={findIdAction}
                            />
                        </div>
                        <div className={"modal-footer pt-3 justify-content-center"}>
                            <button className={"btn btn-primary btn-md"} onClick={findIdAction}>인증메일 발송</button>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}

export default PWModal;
